var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cms-dashboard" },
    [
      _c(
        "div",
        { staticClass: "cms-dashboard__column" },
        [_c("cms-welcome", { staticClass: "cms-dashboard__panel" })],
        1
      ),
      _vm._v(" "),
      _vm.abo
        ? _c("div", { staticClass: "cms-dashboard__column" }, [
            _c("div", { staticClass: "cms-dashboard__panel" }, [
              _c("div", { staticClass: "cms-welcome" }, [
                _c("div", { staticClass: "cms-welcome__content" }, [
                  _c("h1", {
                    staticClass: "cms-welcome__title",
                    domProps: { innerHTML: _vm._s(_vm.$t("Mijn abonnement")) },
                  }),
                  _vm._v(" "),
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t("U hebt het <strong>@name</strong> abonnement", {
                          "@name": _vm.abo,
                        })
                      ),
                    },
                  }),
                  _vm._v(" "),
                  _vm.boosters.length
                    ? _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("met volgende geïnstalleerde boosters")
                          ) + ":\n                        "
                        ),
                        _c(
                          "ul",
                          _vm._l(_vm.boosters, function (booster) {
                            return _c("li", [_vm._v(_vm._s(booster))])
                          }),
                          0
                        ),
                      ])
                    : _vm._e(),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("router-view", {
        attrs: { name: "childview" },
        on: { cancel: _vm.close },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }